<template>
<div class="authDialog" v-if="dialogVisible">
    <el-dialog title="团长申请信息" :visible.sync="dialogVisible" width="600px" center>
        <div class="title">
            <div class="box"><span> 团长信息：</span><img :src="item.logourl " alt="" class="img"><span>{{item.headername}} </span></div>
            <div class="box"><span class="innerbox">联系电话：{{item.linktel}}</span><span class="innerbox">提交时间：{{item.datetime}}</span></div>
            <div class="box">已支付：￥{{item.ordermoney}}</div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="item.ppinfo" style="width: 100%" :show-header="false" ref="multipleTable"
                      @select="handleSelectionChange"  @row-click="handleRowChange">
                <el-table-column type="selection" width="30"></el-table-column>
                <el-table-column prop="orderno" label="地址">
                    <template slot-scope="scope">
                        <div class="mapaddress">
                            <div class="mapaddress-box">
                                <div class="mapaddress-innerbox">提货点：{{scope.row.ppname}}</div>
                                <div  class="mapaddress-innerbox">提货点联系人：{{scope.row.linkman}}</div>
                            </div>
                            <div class="mapaddress-box">
                                <div  class="mapaddress-innerbox">地址：{{scope.row.address}}</div>
                                <div  class="mapaddress-innerbox">提货点电话：{{scope.row.linktel}}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm form">
            <el-form-item label="设置团长佣金（%）" prop="headerrate" class="content">
                <el-input v-model.trim="item.headerrate" placeholder="请输入团长佣金" min="0" max="100" clearable></el-input>
            </el-form-item>
            <el-form-item label="设置推荐团长佣金（%）" prop="recommendrate" class="content">
                <el-input v-model.trim="item.recommendrate" placeholder="请输入推荐团长佣金" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="reject">不通过</el-button>
            <el-button type="primary" @click="pass">通过</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {getHostHeaderAuditInfo, uploadHostHeaderAuditInfo} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'authDialog',
    data() {
        let validateHeaderrate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        let validateRecommendrate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('推荐团长佣金团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        return {
            item: {
                datetime: '',
                headername: '',
                linktel: '',
                logourl: '',
                headerrate: '',
                recommendrate: '',
                ordermoney: 0,
                ppinfo: []
            },
            selectedPpList: [],
            dialogVisible: false,
            param: {
                headerinnerid: ''
            },
            rules: {
                headerrate: [
                    {required: true, message: '请输入提团长佣金', trigger: 'blur'},
                    {pattern: /^(0|[1-9][0-9]*)+(\.[0-9]{1,2})?$/, message: '请输入正确的团长佣金(2位小数)', trigger: 'blur'},
                    {validator: validateHeaderrate, trigger: 'blur'},
                ],
                recommendrate: [
                    {required: true, message: '请输入推荐团长佣金', trigger: 'blur'},
                    {pattern: /^(0|[1-9][0-9]*)+(\.[0-9]{1,2})?$/, message: '请输入正确的推荐团长佣金(2位小数)', trigger: 'blur'},
                    {validator: validateRecommendrate, trigger: 'blur'},
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        handleSelectionChange(selection, row) {
            this.selectedPpList = selection
        },
        handleRowChange(row) {
            this.selectedPpList.forEach((obj, i) => {
                if (obj.ppid === row.ppid) {

                }
            })
            this.selectedPpList.forEach((obj, i) => {
                if (row.ppid == obj.ppid) {
                    this.$refs.multipleTable.toggleRowSelection(row, false)
                    this.selectedPpList.splice(i, 1)
                    flag = true
                }
            })
            if (!flag) {
                this.$refs.multipleTable.toggleRowSelection(row)
                this.selectedPpList.push(row)
            }
        },
        openDialog(row) {
            this.dialogVisible = true
            this.param.headerinnerid = row.headerinnerid
            this._getView()
        },
        cancel() {
            this.dialogVisible = false
        },
        reject() {
            this.$confirm('确认驳回团长申请', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    headerinnerid: this.param.headerinnerid,
                    hostroletype: 0,
                    headerrate: '',
                    recommendrate: '',
                    ppid: '',
                    result: 0
                }
                this._save(obj)
            })
        },
        pass() {
            if (!this.selectedPpList.length) {
                this.$message.error('请选择提货点')
                return false
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认通过团长申请', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        let ppid = []
                        this.selectedPpList.forEach(obj => {
                            ppid.push(obj.ppid)
                        })
                        let obj = {
                            headerinnerid: this.param.headerinnerid,
                            hostroletype: 0,
                            headerrate: this.item.headerrate,
                            recommendrate: this.item.recommendrate,
                            ppid: ppid.join(','),
                            result: 1
                        }
                        this._save(obj)
                    })
                }
            })

        },
        _save(obj) {
            this.setLoading(true)
            uploadHostHeaderAuditInfo({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success('审核成功')
                    this.$emit('getList')
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getHostHeaderAuditInfo({
                data: Object.assign({}, this.param),
                success: data => {
                    this.item = data.data
                    this.$nextTick(() => {
                        this.$refs.multipleTable.toggleAllSelection(true)
                    })
                    this.selectedPpList = this.item.ppinfo
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user', 'params', 'brandBusiness'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.authDialog {
    .title {
        font-size: 14px;
        border-bottom: 1px solid  #DCDFE6 ;
        .box {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin: 0 10px;
            }
            .innerbox{
                width: 50%;
            }
        }
    }
    .mapaddress{
        display: flex;
        background: #F0F2F5;
        padding: 10px 20px;
        box-sizing: border-box;
        .mapaddress-box{
            width: 50%;
            .mapaddress-innerbox+.mapaddress-innerbox{
                margin-top: 20px;
            }
        }
    }
    .el-dialog .el-dialog__body{
        padding-bottom: 0;
    }
    .el-dialog .el-button{
        margin-bottom: 0;
    }
    .el-table__body-wrapper{
        max-height: 220px;
        overflow-y: auto;
    }
    .form{
        margin-top: 10px;
    }
}
</style>
